// extracted by mini-css-extract-plugin
module.exports = {"link":"_93444fe79c--link--1W80z","content":"_93444fe79c--content--1ouJd"};